import CreateBrokerInvoicePage from './CreateBrokerInvoicePage'

const CreateContractorInvoicePage: React.FC = () => {
  return <CreateBrokerInvoicePage invoiceType="CONTRACTOR" />
}

export default CreateContractorInvoicePage
